﻿import { BaseWidget } from "../BaseWidget";
import { BaseForm } from "./BaseForm";

export class CZ04_2014 extends BaseForm
{
	override updateForm()
	{

	}
}